import React, {useEffect, useState} from "react";
import {TableHeader} from "./TableHeader/TableHeader";
import {useSelector} from "react-redux";
import {Grid} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    headerRow: {
        direction: `rtl`,
        // height: `50px`,
        borderTop: `1px solid #BABABA`,
        backgroundColor: `white`,
        '& .MuiTypography-root': {
            textAlign: `center`
        },
        '& > .MuiGrid-item': {
            borderRight: `1px solid #BABABA`,
            borderBottom: `1px solid #BABABA`,
            padding: `0 15px`,
            '&:last-child': {
                borderLeft: `1px solid #BABABA`,
            }
        }
    }
}));

const headerNamesForItems = [
    {
        caption: "selectColumn",
        displayCaption: "בחירה",
        sortPropertyName: "selectedRow",
        size: 1.5
    },
    {
        caption: "printColumn",
        displayCaption: "תצוגה",
        sortPropertyName: "",
        size: 1
    },
    {
        caption: "barcodeColumn",
        displayCaption: "קוד פריט",
        sortPropertyName: "EffectiveBarCode",
        size: 3
    },
    {
        caption: "productNameColumn",
        displayCaption: "תיאור קצר",
        sortPropertyName: "ProductName",
    },
    {
        caption: "russianNameColumn",
        displayCaption: "תיאור ברוסית",
        sortPropertyName: "RussianProductName",
    },
    {
        caption: "priceColumn",
        displayCaption: "מחיר רגיל",
        sortPropertyName: "Price",
        size: 1.5
    },
    {
        caption: "copiesColumn",
        displayCaption: "העתקים",
        sortPropertyName: "",
        size: 1.5
    },
    {
        caption: "alreadyPrintedColumn",
        displayCaption: "האם נשלח להדפסה",
        sortPropertyName: "isAlreadyPrinted",
        size: 1.5
    },
];

const headerNamesForPromos = [
    {
        caption: "selectColumn",
        displayCaption: "בחירה",
        sortPropertyName: "selectedRow",
        size: 1.5
    },
    {
        caption: "printColumn",
        displayCaption: "תצוגה",
        sortPropertyName: "",
        size: 1
    },
    {
        caption: "saleIdColumn",
        displayCaption: "מספר מבצע",
        sortPropertyName: "SaleIdentifier",
        size: 1
    },
    {
        caption: "saleTypeColumn",
        displayCaption: "סוג מבצע",
        sortPropertyName: "SaleType",
        size: 1
    },
    {
        caption: "saleEndDateColumn",
        displayCaption: "תאריך סיום",
        sortPropertyName: "SaleEndDateTimeUtc",
        size: 1.5
    },
    {
        caption: "barCodesColumn",
        displayCaption: "קודי פריטים",
        sortPropertyName: "BarCodes",
    },
    {
        caption: "promoDescColumn",
        displayCaption: "תאור קצר",
        sortPropertyName: "PromotionDescription",
    },
    {
        caption: "russianDescColumn",
        displayCaption: "תיאור ברוסית",
        sortPropertyName: "RussianPromotionDescription",
    },
    {
        caption: "saleValue1Column",
        displayCaption: "ערך מבצע1",
        sortPropertyName: "SaleVal1",
        size: 1
    },
    {
        caption: "saleValue2Column",
        displayCaption: "ערך מבצע2",
        sortPropertyName: "SaleVal2",
        size: 1
    },
    {
        caption: "regPriceColumn",
        displayCaption: "מחיר רגיל",
        sortPropertyName: "RegularPrice",
        size: 1
    },
    {
        caption: "membersColumn",
        displayCaption: "חברי מועדון",
        sortPropertyName: "Members",
        size: 1
    },
    {
        caption: "copiesColumn",
        displayCaption: "העתקים",
        sortPropertyName: "",
        size: 1.5
    },
    {
        caption: "alreadyPrintedColumn",
        displayCaption: "האם נשלח להדפסה",
        sortPropertyName: "isAlreadyPrinted",
        size: 1.5
    },
];

export const TableHeaders = () => {
    const classes = useStyles();
    const {contentData} = useSelector(state => state);
    let [sortTarget, setSortTarget] = useState(null);
    const [tableHeadersData, setTableHeaders] = useState([]);
    useEffect(() => {
        if (contentData.isActivePromosScreen) {
            setTableHeaders(headerNamesForPromos);
        } else {
            setTableHeaders(headerNamesForItems);
        }
    }, [
        contentData.isActivePromosScreen
    ])
    const tableHeaders = tableHeadersData.map((key, index) => {
        return (
            <TableHeader
                key={index}
                caption={key.caption}
                sortPropertyName={key.sortPropertyName}
                displayCaption={key.displayCaption}
                size={key.size}
                sortTarget={sortTarget}
                setSortTarget={setSortTarget}
            />
        );
    });

    return (
        <Grid columns={24} container
              className={classes.headerRow}
        >
            {tableHeaders}
        </Grid>
    );
};
